import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { getRole } from '../../reducers';

class IndexRedirect extends React.Component {
  componentWillMount() {
    this.props.replace(this.props.role === 'installer' ? '/schedule' : '/phases');
  }

  render() { return null; }
}

IndexRedirect.propTypes = {
  replace: PropTypes.func,
  role: PropTypes.string,
};

export default connect(state => ({
  role: getRole(state),
}), { replace: routerActions.replace })(IndexRedirect);



// WEBPACK FOOTER //
// ./client/app/screens/main/redirect.jsx